 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXT9781611533088 from '@/components/Text/9781611533088'
 import TEXT97816115330881 from '@/components/Text/97816115330881'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXT97816115330882 from '@/components/Text/97816115330882'
 import TEXT97816115330883 from '@/components/Text/97816115330883'
 import TEXT97816115330884 from '@/components/Text/97816115330884'
 import TEXT97816115330885 from '@/components/Text/97816115330885'
 import TEXT97816115330886 from '@/components/Text/97816115330886'
 import TEXT97816115330887 from '@/components/Text/97816115330887'
 import TEXT97816115330888 from '@/components/Text/97816115330888'
 import TEXT97816115330889 from '@/components/Text/97816115330889'
 import TEXT978161153308810 from '@/components/Text/978161153308810'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/97816115330882",
 			"name" : "Text/97816115330882",
 			"component" : TEXT97816115330882
 		},
 		{
 			"path" : "/Text/97816115330883",
 			"name" : "Text/97816115330883",
 			"component" : TEXT97816115330883
 		},
 		{
 			"path" : "/Text/97816115330884",
 			"name" : "Text/97816115330884",
 			"component" : TEXT97816115330884
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js